import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Apply dark background immediately
document.documentElement.style.backgroundColor = '#0A0A0A';
document.body.style.backgroundColor = '#0A0A0A';

// Create a loading screen element
const loadingScreen = document.createElement('div');
loadingScreen.style.backgroundColor = '#0A0A0A';
loadingScreen.style.position = 'fixed';
loadingScreen.style.top = '0';
loadingScreen.style.left = '0';
loadingScreen.style.width = '100%';
loadingScreen.style.height = '100%';
loadingScreen.style.zIndex = '9999';

// Add loading screen to body
document.body.appendChild(loadingScreen);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove loading screen after React has mounted
setTimeout(() => {
  loadingScreen.remove();
}, 500);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
